window.Products.Accessory.Headband = function() {
};
window.Products.Accessory.Headband.inherits(window.Products.Accessory.Accessory);

window.Products.Accessory.Headband.id = 59;
window.Products.Accessory.Headband.slug = 'headband';
window.Products.Accessory.Headband.has_3d = true;
window.Products.Accessory.Headband.dpi = 150;

window.Products.Accessory.Headband.prototype.set3dProperties = function(modelViewer) {
	this.updateThreeTexture(modelViewer);
};

window.Products.Accessory.Headband.prototype.setThreeControls = function(controls) {
	controls.minDistance = 2.1;
	controls.maxDistance = 3.8;
};

window.Products.Accessory.Headband.prototype.updateThreeTexture = function(modelViewer) {
	modelViewer.object.children[0].material.map = modelViewer.texture;
	modelViewer.object.children[1].material.map = modelViewer.texture;
};